import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { RadioGroup, RadioGroupItem } from '../components/ui/radio-group';
import { Checkbox } from '../components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { CreditCard, Truck, ArrowRight, Loader2, Building2, User, FileText } from 'lucide-react';
import { toast } from 'sonner';

// Romanian counties with cities/localities
const romanianCounties = {
  'București': ['Sector 1', 'Sector 2', 'Sector 3', 'Sector 4', 'Sector 5', 'Sector 6'],
  'Alba': ['Alba Iulia', 'Aiud', 'Blaj', 'Câmpeni', 'Cugir', 'Sebeș', 'Zlatna'],
  'Arad': ['Arad', 'Chișineu-Criș', 'Curtici', 'Ineu', 'Lipova', 'Nădlac', 'Pâncota', 'Pecica', 'Sântana', 'Sebiș'],
  'Argeș': ['Pitești', 'Câmpulung', 'Curtea de Argeș', 'Mioveni', 'Costești', 'Stefănești', 'Topoloveni'],
  'Bacău': ['Bacău', 'Onești', 'Moinești', 'Comănești', 'Buhuși', 'Dărmănești', 'Târgu Ocna', 'Slănic-Moldova'],
  'Bihor': ['Oradea', 'Salonta', 'Marghita', 'Beiuș', 'Aleșd', 'Ștei', 'Valea lui Mihai', 'Nucet'],
  'Bistrița-Năsăud': ['Bistrița', 'Năsăud', 'Beclean', 'Sângeorz-Băi'],
  'Botoșani': ['Botoșani', 'Dorohoi', 'Darabani', 'Săveni', 'Flămânzi', 'Ștefănești'],
  'Brașov': ['Brașov', 'Făgăraș', 'Săcele', 'Codlea', 'Râșnov', 'Zărnești', 'Victoria', 'Rupea', 'Predeal'],
  'Brăila': ['Brăila', 'Însurăței', 'Făurei', 'Ianca'],
  'Buzău': ['Buzău', 'Râmnicu Sărat', 'Nehoiu', 'Pogoanele', 'Pătârlagele'],
  'Caraș-Severin': ['Reșița', 'Caransebeș', 'Bocșa', 'Oravița', 'Moldova Nouă', 'Oțelu Roșu', 'Anina'],
  'Călărași': ['Călărași', 'Oltenița', 'Budești', 'Fundulea', 'Lehliu Gară'],
  'Cluj': ['Cluj-Napoca', 'Turda', 'Dej', 'Câmpia Turzii', 'Gherla', 'Huedin'],
  'Constanța': ['Constanța', 'Mangalia', 'Medgidia', 'Năvodari', 'Cernavodă', 'Eforie', 'Techirghiol', 'Murfatlar', 'Hârșova'],
  'Covasna': ['Sfântu Gheorghe', 'Târgu Secuiesc', 'Covasna', 'Baraolt', 'Întorsura Buzăului'],
  'Dâmbovița': ['Târgoviște', 'Moreni', 'Pucioasa', 'Găești', 'Fieni', 'Titu'],
  'Dolj': ['Craiova', 'Băilești', 'Calafat', 'Filiași', 'Dăbuleni', 'Segarcea'],
  'Galați': ['Galați', 'Tecuci', 'Târgu Bujor', 'Berești'],
  'Giurgiu': ['Giurgiu', 'Bolintin-Vale', 'Mihăilești'],
  'Gorj': ['Târgu Jiu', 'Motru', 'Rovinari', 'Bumbești-Jiu', 'Târgu Cărbunești', 'Turceni', 'Novaci', 'Tismana'],
  'Harghita': ['Miercurea Ciuc', 'Odorheiu Secuiesc', 'Gheorgheni', 'Toplița', 'Cristuru Secuiesc', 'Bălan', 'Borsec', 'Băile Tușnad'],
  'Hunedoara': ['Deva', 'Hunedoara', 'Petroșani', 'Lupeni', 'Vulcan', 'Brad', 'Orăștie', 'Petrila', 'Simeria', 'Hațeg'],
  'Ialomița': ['Slobozia', 'Fetești', 'Urziceni', 'Țăndărei', 'Amara', 'Căzănești'],
  'Iași': ['Iași', 'Pașcani', 'Hârlău', 'Târgu Frumos'],
  'Ilfov': ['Voluntari', 'Pantelimon', 'Buftea', 'Popești-Leordeni', 'Chitila', 'Bragadiru', 'Otopeni', 'Măgurele', 'Cornetu', '1 Decembrie', 'Afumați', 'Balotești', 'Berceni', 'Brănești', 'Cernica', 'Chiajna', 'Ciolpani', 'Ciorogârla', 'Clinceni', 'Copăceni', 'Dascălu', 'Dobroești', 'Domnești', 'Dragomirești-Vale', 'Găneasa', 'Glina', 'Grădiștea', 'Gruiu', 'Jilava', 'Moara Vlăsiei', 'Mogoșoaia', 'Nuci', 'Petrăchioaia', 'Periș', 'Snagov', 'Ștefăneștii de Jos', 'Tunari', 'Vidra'],
  'Maramureș': ['Baia Mare', 'Sighetu Marmației', 'Borșa', 'Vișeu de Sus', 'Baia Sprie', 'Târgu Lăpuș', 'Seini', 'Șomcuta Mare', 'Cavnic', 'Tăuții-Măgherăuș'],
  'Mehedinți': ['Drobeta-Turnu Severin', 'Orșova', 'Strehaia', 'Baia de Aramă', 'Vânju Mare'],
  'Mureș': ['Târgu Mureș', 'Reghin', 'Sighișoara', 'Târnăveni', 'Luduș', 'Sovata', 'Iernut', 'Miercurea Nirajului', 'Sângeorgiu de Pădure', 'Cristești'],
  'Neamț': ['Piatra Neamț', 'Roman', 'Târgu Neamț', 'Roznov', 'Bicaz'],
  'Olt': ['Slatina', 'Caracal', 'Corabia', 'Balș', 'Scornicești', 'Drăgănești-Olt', 'Piatra-Olt'],
  'Prahova': ['Ploiești', 'Câmpina', 'Băicoi', 'Breaza', 'Bușteni', 'Comarnic', 'Mizil', 'Sinaia', 'Slănic', 'Urlați', 'Vălenii de Munte', 'Azuga', 'Boldești-Scăeni', 'Plopeni'],
  'Satu Mare': ['Satu Mare', 'Carei', 'Negrești-Oaș', 'Tășnad', 'Ardud', 'Livada'],
  'Sălaj': ['Zalău', 'Șimleu Silvaniei', 'Jibou', 'Cehu Silvaniei'],
  'Sibiu': ['Sibiu', 'Mediaș', 'Cisnădie', 'Agnita', 'Avrig', 'Copșa Mică', 'Dumbrăveni', 'Miercurea Sibiului', 'Ocna Sibiului', 'Săliște', 'Tălmaciu'],
  'Suceava': ['Suceava', 'Fălticeni', 'Rădăuți', 'Câmpulung Moldovenesc', 'Vatra Dornei', 'Gura Humorului', 'Siret', 'Broșteni', 'Cajvana', 'Dolhasca', 'Frasin', 'Liteni', 'Milișăuți', 'Salcea', 'Solca', 'Vicovu de Sus'],
  'Teleorman': ['Alexandria', 'Roșiori de Vede', 'Turnu Măgurele', 'Zimnicea', 'Videle'],
  'Timiș': ['Timișoara', 'Lugoj', 'Sânnicolau Mare', 'Jimbolia', 'Făget', 'Buziaș', 'Deta', 'Gătaia', 'Recaș', 'Ciacova'],
  'Tulcea': ['Tulcea', 'Babadag', 'Măcin', 'Isaccea', 'Sulina'],
  'Vaslui': ['Vaslui', 'Bârlad', 'Huși', 'Negrești', 'Murgeni'],
  'Vâlcea': ['Râmnicu Vâlcea', 'Drăgășani', 'Băile Olănești', 'Călimănești', 'Horezu', 'Băile Govora', 'Berbești', 'Bălcești', 'Brezoi', 'Ocnele Mari'],
  'Vrancea': ['Focșani', 'Adjud', 'Mărășești', 'Panciu', 'Odobești'],
};

export const CheckoutPage = () => {
  const {
    t,
    cart,
    cartTotal,
    clearCart,
    customer,
    currency,
    getLocalizedText,
    API,
    language,
  } = useApp();
  const navigate = useNavigate();

  const [checkoutMode, setCheckoutMode] = useState(customer ? 'account' : 'guest'); // 'account' or 'guest'
  const [paymentMethod, setPaymentMethod] = useState('cod');
  const [loading, setLoading] = useState(false);
  const [wantInvoice, setWantInvoice] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [wantNewsletter, setWantNewsletter] = useState(false);
  
  const [formData, setFormData] = useState({
    email: customer?.email || '',
    firstName: customer?.first_name || '',
    lastName: customer?.last_name || '',
    phone: '',
    country: 'România',
    county: '',
    locality: '',
    address: '',
    postalCode: '',
    notes: '',
    // Invoice fields
    invoiceFirstName: '',
    invoiceLastName: '',
    invoiceCUI: '',
    invoicePhone: '',
    invoiceCounty: '',
    invoiceLocality: '',
    invoiceAddress: '',
    invoicePostalCode: '',
  });

  const [localities, setLocalities] = useState([]);
  const [invoiceLocalities, setInvoiceLocalities] = useState([]);

  // Update localities when county changes
  useEffect(() => {
    if (formData.county && romanianCounties[formData.county]) {
      setLocalities(romanianCounties[formData.county]);
      setFormData(prev => ({ ...prev, locality: '' }));
    } else {
      setLocalities([]);
    }
  }, [formData.county]);

  // Update invoice localities when invoice county changes
  useEffect(() => {
    if (formData.invoiceCounty && romanianCounties[formData.invoiceCounty]) {
      setInvoiceLocalities(romanianCounties[formData.invoiceCounty]);
      setFormData(prev => ({ ...prev, invoiceLocality: '' }));
    } else {
      setInvoiceLocalities([]);
    }
  }, [formData.invoiceCounty]);

  const currencySymbol = currency === 'eur' ? '€' : 'RON';
  const shippingCost = 20; // Fixed 20 LEI shipping
  const codFee = paymentMethod === 'cod' ? 3 : 0; // +3 LEI for COD
  const total = cartTotal + shippingCost + codFee;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (cart.length === 0) {
      toast.error('Coșul este gol');
      return;
    }

    if (!acceptTerms) {
      toast.error('Trebuie să accepți termenii și condițiile');
      return;
    }

    if (!formData.county || !formData.locality) {
      toast.error('Te rugăm să selectezi județul și localitatea');
      return;
    }

    setLoading(true);

    try {
      // Create order
      const orderData = {
        customer_id: customer?.id || null,
        guest_email: customer ? null : formData.email,
        items: cart.map((item) => ({
          product_id: item.product_id,
          quantity: item.quantity,
        })),
        shipping_address: {
          first_name: formData.firstName,
          last_name: formData.lastName,
          phone: formData.phone,
          address: formData.address,
          city: formData.locality,
          county: formData.county,
          postal_code: formData.postalCode,
          country: formData.country,
        },
        billing_address: wantInvoice ? {
          first_name: formData.invoiceFirstName,
          last_name: formData.invoiceLastName,
          cui: formData.invoiceCUI,
          phone: formData.invoicePhone,
          address: formData.invoiceAddress,
          city: formData.invoiceLocality,
          county: formData.invoiceCounty,
          postal_code: formData.invoicePostalCode,
          country: formData.country,
        } : null,
        payment_method: paymentMethod,
        currency: currency,
        notes: formData.notes,
        want_invoice: wantInvoice,
        newsletter_optin: wantNewsletter,
        shipping_cost: shippingCost,
        cod_fee: codFee,
      };

      const orderRes = await fetch(`${API}/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(localStorage.getItem('rani_customer_token') && {
            Authorization: `Bearer ${localStorage.getItem('rani_customer_token')}`,
          }),
        },
        body: JSON.stringify(orderData),
      });

      if (!orderRes.ok) {
        const err = await orderRes.json();
        throw new Error(err.detail || 'Eroare la procesarea comenzii');
      }

      const order = await orderRes.json();

      if (paymentMethod === 'stripe') {
        // Redirect to Stripe
        const checkoutRes = await fetch(`${API}/payments/checkout`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            order_id: order.id,
            origin_url: window.location.origin,
          }),
        });

        if (!checkoutRes.ok) {
          throw new Error('Eroare la procesarea plății');
        }

        const checkout = await checkoutRes.json();
        window.location.href = checkout.url;
      } else if (paymentMethod === 'bank_transfer') {
        // Bank transfer - redirect to confirmation with bank details
        clearCart();
        toast.success('Comandă plasată! Veți primi detaliile de plată pe email.');
        navigate(`/order-confirmation/${order.id}?payment=bank_transfer`);
      } else {
        // Cash on delivery
        clearCart();
        toast.success('Comandă plasată cu succes!');
        navigate(`/order-confirmation/${order.id}`);
      }
    } catch (err) {
      console.error('Checkout error:', err);
      toast.error(err.message || 'Eroare la procesarea comenzii');
    } finally {
      setLoading(false);
    }
  };

  if (cart.length === 0) {
    return (
      <Layout>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 text-center">
          <h1 className="font-heading text-3xl font-bold mb-4">Coșul tău este gol</h1>
          <Button asChild>
            <Link to="/shop">Continuă cumpărăturile</Link>
          </Button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-8" data-testid="checkout-page">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
          <Link to="/" className="hover:text-primary">Acasă</Link>
          <span>/</span>
          <Link to="/cart" className="hover:text-primary">Coș</Link>
          <span>/</span>
          <span className="text-foreground">Finalizare comandă</span>
        </nav>

        <h1 className="font-heading text-3xl font-bold text-[#1A1625] mb-8">Finalizare comandă</h1>

        {/* Guest/Account Toggle */}
        {!customer && (
          <div className="bg-white border border-gray-100 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-4">
              <Button
                type="button"
                variant={checkoutMode === 'guest' ? 'default' : 'outline'}
                onClick={() => setCheckoutMode('guest')}
                className="flex items-center gap-2"
              >
                <User className="h-4 w-4" />
                Comandă ca vizitator
              </Button>
              <Button
                type="button"
                variant={checkoutMode === 'account' ? 'default' : 'outline'}
                onClick={() => setCheckoutMode('account')}
                className="flex items-center gap-2"
              >
                <User className="h-4 w-4" />
                Am cont / Creează cont
              </Button>
            </div>
            {checkoutMode === 'account' && (
              <div className="mt-4 text-sm text-muted-foreground">
                <Link to="/account/login" className="text-primary hover:underline">Conectează-te</Link> sau completează formularul pentru a crea un cont.
              </div>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Form */}
            <div className="lg:col-span-2 space-y-6">
              {/* DATE LIVRARE */}
              <div className="bg-white border border-gray-100 rounded-lg p-6">
                <h2 className="font-heading text-xl font-semibold mb-6 text-primary">DATE LIVRARE</h2>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="sm:col-span-2">
                    <Label htmlFor="email">Email *</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                      data-testid="checkout-email"
                    />
                  </div>
                  <div>
                    <Label htmlFor="firstName">Prenume *</Label>
                    <Input
                      id="firstName"
                      name="firstName"
                      required
                      value={formData.firstName}
                      onChange={handleInputChange}
                      data-testid="checkout-firstname"
                    />
                  </div>
                  <div>
                    <Label htmlFor="lastName">Nume de familie *</Label>
                    <Input
                      id="lastName"
                      name="lastName"
                      required
                      value={formData.lastName}
                      onChange={handleInputChange}
                      data-testid="checkout-lastname"
                    />
                  </div>
                  <div className="sm:col-span-2">
                    <Label htmlFor="phone">Telefon *</Label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      required
                      placeholder="07xxxxxxxx"
                      value={formData.phone}
                      onChange={handleInputChange}
                      data-testid="checkout-phone"
                    />
                  </div>

                  {/* Country & County on same row */}
                  <div>
                    <Label htmlFor="country">Țară *</Label>
                    <Input
                      id="country"
                      name="country"
                      value={formData.country}
                      disabled
                      className="bg-gray-50"
                      data-testid="checkout-country"
                    />
                  </div>
                  <div>
                    <Label htmlFor="county">Județ *</Label>
                    <Select value={formData.county} onValueChange={(val) => handleSelectChange('county', val)}>
                      <SelectTrigger data-testid="checkout-county">
                        <SelectValue placeholder="Selectează județul" />
                      </SelectTrigger>
                      <SelectContent className="max-h-[300px]">
                        {Object.keys(romanianCounties).sort().map((county) => (
                          <SelectItem key={county} value={county}>{county}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  {/* Locality */}
                  <div className="sm:col-span-2">
                    <Label htmlFor="locality">Localitate *</Label>
                    <Select 
                      value={formData.locality} 
                      onValueChange={(val) => handleSelectChange('locality', val)}
                      disabled={!formData.county}
                    >
                      <SelectTrigger data-testid="checkout-locality">
                        <SelectValue placeholder={formData.county ? "Selectează localitatea" : "Selectează mai întâi județul"} />
                      </SelectTrigger>
                      <SelectContent className="max-h-[300px]">
                        {localities.map((loc) => (
                          <SelectItem key={loc} value={loc}>{loc}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  {/* Address */}
                  <div className="sm:col-span-2">
                    <Label htmlFor="address">Adresă completă (stradă, număr, bloc, scară, apartament) *</Label>
                    <Input
                      id="address"
                      name="address"
                      required
                      placeholder="Str. Exemplu, Nr. 10, Bl. A, Sc. 1, Ap. 5"
                      value={formData.address}
                      onChange={handleInputChange}
                      data-testid="checkout-address"
                    />
                  </div>

                  {/* Postal Code - not mandatory */}
                  <div>
                    <Label htmlFor="postalCode">Cod poștal</Label>
                    <Input
                      id="postalCode"
                      name="postalCode"
                      placeholder="(opțional)"
                      value={formData.postalCode}
                      onChange={handleInputChange}
                      data-testid="checkout-postal"
                    />
                  </div>
                </div>
              </div>

              {/* Invoice Checkbox */}
              <div className="bg-white border border-gray-100 rounded-lg p-6">
                <div className="flex items-center gap-3">
                  <Checkbox
                    id="wantInvoice"
                    checked={wantInvoice}
                    onCheckedChange={setWantInvoice}
                    data-testid="want-invoice"
                  />
                  <Label htmlFor="wantInvoice" className="flex items-center gap-2 cursor-pointer">
                    <FileText className="h-4 w-4" />
                    Doresc factură fiscală
                  </Label>
                </div>

                {/* Invoice Form */}
                {wantInvoice && (
                  <div className="mt-6 pt-6 border-t grid sm:grid-cols-2 gap-4">
                    <h3 className="sm:col-span-2 font-semibold text-[#1A1625]">Date facturare</h3>
                    <div>
                      <Label htmlFor="invoiceFirstName">Prenume *</Label>
                      <Input
                        id="invoiceFirstName"
                        name="invoiceFirstName"
                        required={wantInvoice}
                        value={formData.invoiceFirstName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <Label htmlFor="invoiceLastName">Nume de familie *</Label>
                      <Input
                        id="invoiceLastName"
                        name="invoiceLastName"
                        required={wantInvoice}
                        value={formData.invoiceLastName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <Label htmlFor="invoiceCUI">CUI (opțional - pentru firme)</Label>
                      <Input
                        id="invoiceCUI"
                        name="invoiceCUI"
                        placeholder="RO12345678"
                        value={formData.invoiceCUI}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <Label htmlFor="invoicePhone">Telefon *</Label>
                      <Input
                        id="invoicePhone"
                        name="invoicePhone"
                        type="tel"
                        required={wantInvoice}
                        value={formData.invoicePhone}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <Label htmlFor="invoiceCounty">Județ *</Label>
                      <Select value={formData.invoiceCounty} onValueChange={(val) => handleSelectChange('invoiceCounty', val)}>
                        <SelectTrigger>
                          <SelectValue placeholder="Selectează județul" />
                        </SelectTrigger>
                        <SelectContent className="max-h-[300px]">
                          {Object.keys(romanianCounties).sort().map((county) => (
                            <SelectItem key={county} value={county}>{county}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div>
                      <Label htmlFor="invoiceLocality">Localitate *</Label>
                      <Select 
                        value={formData.invoiceLocality} 
                        onValueChange={(val) => handleSelectChange('invoiceLocality', val)}
                        disabled={!formData.invoiceCounty}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Selectează localitatea" />
                        </SelectTrigger>
                        <SelectContent className="max-h-[300px]">
                          {invoiceLocalities.map((loc) => (
                            <SelectItem key={loc} value={loc}>{loc}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="sm:col-span-2">
                      <Label htmlFor="invoiceAddress">Adresă *</Label>
                      <Input
                        id="invoiceAddress"
                        name="invoiceAddress"
                        required={wantInvoice}
                        value={formData.invoiceAddress}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <Label htmlFor="invoicePostalCode">Cod poștal</Label>
                      <Input
                        id="invoicePostalCode"
                        name="invoicePostalCode"
                        value={formData.invoicePostalCode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* METODA DE LIVRARE */}
              <div className="bg-white border border-gray-100 rounded-lg p-6">
                <h2 className="font-heading text-xl font-semibold mb-6 text-primary">METODĂ DE LIVRARE</h2>
                <div className="flex items-center justify-between p-4 border rounded-lg bg-purple-50 border-primary">
                  <div className="flex items-center gap-3">
                    <Truck className="h-5 w-5 text-primary" />
                    <span className="font-medium">Curier Rapid</span>
                  </div>
                  <span className="text-xl font-bold text-primary">20 LEI</span>
                </div>
              </div>

              {/* METODA DE PLATĂ */}
              <div className="bg-white border border-gray-100 rounded-lg p-6">
                <h2 className="font-heading text-xl font-semibold mb-6 text-primary">METODĂ DE PLATĂ</h2>
                <RadioGroup value={paymentMethod} onValueChange={setPaymentMethod}>
                  <div className="space-y-3">
                    {/* Cash on Delivery */}
                    <label
                      className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition-colors ${
                        paymentMethod === 'cod' ? 'border-primary bg-purple-50' : 'border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <RadioGroupItem value="cod" id="cod" className="mt-1" data-testid="payment-cod" />
                      <Truck className="h-5 w-5 text-muted-foreground mt-0.5" />
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <p className="font-medium">Plata la livrare</p>
                          <span className="text-sm font-medium text-orange-600">(+3 lei taxă procesare)</span>
                        </div>
                        <p className="text-sm text-muted-foreground mt-1">Plata se face la livrare, direct curierului.</p>
                      </div>
                    </label>

                    {/* Card Payment */}
                    <label
                      className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition-colors ${
                        paymentMethod === 'stripe' ? 'border-primary bg-purple-50' : 'border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <RadioGroupItem value="stripe" id="stripe" className="mt-1" data-testid="payment-stripe" />
                      <CreditCard className="h-5 w-5 text-muted-foreground mt-0.5" />
                      <div>
                        <p className="font-medium">Plata cu cardul</p>
                        <p className="text-sm text-muted-foreground mt-1">Plată securizată prin Stripe. Acceptăm Visa, Mastercard, Apple Pay.</p>
                      </div>
                    </label>

                    {/* Bank Transfer */}
                    <label
                      className={`flex items-start gap-4 p-4 border rounded-lg cursor-pointer transition-colors ${
                        paymentMethod === 'bank_transfer' ? 'border-primary bg-purple-50' : 'border-gray-200 hover:border-gray-300'
                      }`}
                    >
                      <RadioGroupItem value="bank_transfer" id="bank_transfer" className="mt-1" data-testid="payment-bank" />
                      <Building2 className="h-5 w-5 text-muted-foreground mt-0.5" />
                      <div>
                        <p className="font-medium">Transfer bancar</p>
                        <p className="text-sm text-muted-foreground mt-1">Vei primi pe email factura proformă cu detaliile de plată.</p>
                      </div>
                    </label>
                  </div>
                </RadioGroup>
              </div>

              {/* Observații (Notes) */}
              <div className="bg-white border border-gray-100 rounded-lg p-6">
                <h2 className="font-heading text-xl font-semibold mb-6">Observații</h2>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleInputChange}
                  placeholder="Instrucțiuni speciale pentru livrare..."
                  className="w-full h-24 px-3 py-2 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-primary"
                  data-testid="checkout-notes"
                />
              </div>

              {/* Terms & Newsletter Checkboxes */}
              <div className="bg-white border border-gray-100 rounded-lg p-6 space-y-4">
                <div className="flex items-start gap-3">
                  <Checkbox
                    id="wantNewsletter"
                    checked={wantNewsletter}
                    onCheckedChange={setWantNewsletter}
                    data-testid="newsletter-optin"
                  />
                  <Label htmlFor="wantNewsletter" className="cursor-pointer text-sm text-muted-foreground">
                    Aș dori să primesc e-mailuri exclusive cu reduceri și informații despre produse.
                  </Label>
                </div>
                <div className="flex items-start gap-3">
                  <Checkbox
                    id="acceptTerms"
                    checked={acceptTerms}
                    onCheckedChange={setAcceptTerms}
                    required
                    data-testid="accept-terms"
                  />
                  <Label htmlFor="acceptTerms" className="cursor-pointer text-sm">
                    <span className="text-red-500">*</span> Am citit și sunt de acord cu{' '}
                    <Link to="/page/termeni-si-conditii" className="text-primary hover:underline">
                      Termenii și condițiile
                    </Link>
                  </Label>
                </div>
              </div>
            </div>

            {/* Order Summary */}
            <div className="lg:col-span-1">
              <div className="bg-surface p-6 rounded-lg sticky top-24" data-testid="checkout-summary">
                <h2 className="font-heading text-xl font-semibold mb-6">Sumar comandă</h2>
                
                <div className="space-y-4 mb-6">
                  {cart.map((item) => (
                    <div key={item.product_id} className="flex gap-3">
                      <img
                        src={item.product?.images?.[0] || 'https://images.unsplash.com/photo-1763478959550-13d564c5a62d?q=80&w=100&auto=format&fit=crop'}
                        alt=""
                        className="w-16 h-16 object-cover rounded"
                      />
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium truncate">
                          {getLocalizedText(item.product?.name)}
                        </p>
                        <p className="text-sm text-muted-foreground">Cant: {item.quantity}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="space-y-3 pt-4 border-t mb-6">
                  <div className="flex justify-between text-sm">
                    <span className="text-muted-foreground">Subtotal</span>
                    <span>{cartTotal.toFixed(2)} {currencySymbol}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-muted-foreground">Livrare (Curier Rapid)</span>
                    <span>{shippingCost.toFixed(2)} {currencySymbol}</span>
                  </div>
                  {paymentMethod === 'cod' && (
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Taxă plată la livrare</span>
                      <span>{codFee.toFixed(2)} {currencySymbol}</span>
                    </div>
                  )}
                </div>

                <div className="border-t pt-4 mb-6">
                  <div className="flex justify-between text-lg font-semibold">
                    <span>Total</span>
                    <span className="text-primary">{total.toFixed(2)} {currencySymbol}</span>
                  </div>
                </div>

                <Button
                  type="submit"
                  disabled={loading || !acceptTerms}
                  className="w-full h-12 bg-primary hover:bg-purple-600 text-white rounded-full disabled:opacity-50"
                  data-testid="place-order-btn"
                >
                  {loading ? (
                    <Loader2 className="h-5 w-5 animate-spin" />
                  ) : (
                    <>
                      Plasează comanda <ArrowRight className="ml-2 h-5 w-5" />
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Layout>
  );
};

export default CheckoutPage;
